import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Customer = React.lazy(async () => ({
    default: (await import('@oc/customer/module')).CustomerModule
}))

const Dashboard = React.lazy(async () => ({
    default: (await import('@oc/customer/module')).DashboardModule
}))

export function CustomerComponent() {
    return <SuspenseWhileLoading LazyComponent={Customer} lazyComponentProps={{}} />
}

export function EditCustomerComponent() {
    return <SuspenseWhileLoading LazyComponent={Customer} lazyComponentProps={{editMode: true}} />
}

export function DashboardComponent() {
    return <SuspenseWhileLoading LazyComponent={Dashboard} />
}
